import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getAllLiveAuctionForSeller } from "../../../../redux/action/auctionEvent";
import LiveOffer from "./LiveOffer";
import SpinnersLoading from "../../../loader/SpinnersLoading";

function TodayLiveAuction() {
  const dispatch = useDispatch();

  const { loading, liveAuctionData } = useSelector(
    (state) => state.sellerLiveAuction
  );

  useEffect(() => {
    dispatch(getAllLiveAuctionForSeller());
  }, [dispatch]);

  if (loading) {
    return <SpinnersLoading/>
  }

  return (
    <div>
      <b>Today Live Auction</b>

      <div className="flex flex-wrap gap-1 mt-1 mb-1">
        {liveAuctionData?.map((item,index) => {
          return <LiveOffer singleOffer={item} key={index} />;
        })}
      </div>
    </div>
  );
}

export default TodayLiveAuction;
